

export const currentAccountSelector = (state) => state.currentProject && state.currentProject.account

export const isSubscribedSelector = (state) => {
  const currentAccount = currentAccountSelector(state);
  return currentAccount && currentAccount.is_subscribed;
}

export const isTrialSelector = (state) => {
  const currentAccount = currentAccountSelector(state);
  return currentAccount && currentAccount.is_trial;
};

export const isCustomerSelector = (state) => {
  const currentAccount = currentAccountSelector(state);
  return currentAccount && currentAccount.customer_id;
};

export const isActiveSelector = (state) => (isTrialSelector(state) || isSubscribedSelector(state));



export { 
  currentUserSelector,
  currentCustomerSubscriptionPlanSelector,
  currentCustomerSubscriptionPlanRawIdSelector,
  currentCustomerInfoSelector
} from './user';

export { projectsSelector, myProjectsSelector, sharedProjectsSelector } from './projects';
export { currentProjectActiveDomainsSelector } from './domains';



// WEBPACK FOOTER //
// ./src/reducers/selectors/index.js